import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_72_2180",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_72_2180)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M11.1667 16.1167V7.21675L8.3 10.0833L7.11675 8.88325L12 4L16.8832 8.88325L15.7 10.0833L12.8333 7.21675V16.1167H11.1667ZM5.66675 20C5.21675 20 4.82642 19.8347 4.49575 19.5042C4.16525 19.1736 4 18.7832 4 18.3333V14.95H5.66675V18.3333H18.3333V14.95H20V18.3333C20 18.7832 19.8347 19.1736 19.5042 19.5042C19.1736 19.8347 18.7832 20 18.3333 20H5.66675Z",
				fill: "#5386E4"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
